import React from 'react';
import classes from './Card.module.css';

const Card = ({ children, className = '', padding = 'normal' }) => {
  const paddingClass = padding === 'large' ? classes.paddingLarge : classes.paddingNormal;
  
  return (
    <div className={`${classes.card} ${paddingClass} ${className}`}>
      {children}
    </div>
  );
};

export default Card;
